import { useNavigate } from "react-router";
import { FileText } from "lucide-react";

const Settings = () => {
  const navigate = useNavigate();

  const settingsOptions = [
    { title: "Contact Form Settings", icon: <FileText size={24} />, route: "/settings/contact-form-settings" },
  ];

  return (
    <div className="settings-container flex flex-col items-center mt-16">
      <h1 className="text-2xl font-bold mb-6">Settings</h1>
      <div className="grid grid-cols-2 gap-6 w-full max-w-lg">
        {settingsOptions.map(({ title, icon, route }) => (
          <button
            key={title}
            className="settings-button flex items-center justify-center gap-3 bg-white shadow-md border rounded-lg p-4 w-full text-lg font-medium hover:bg-gray-100 transition"
            onClick={() => navigate(route)}
          >
            {icon} {title}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Settings;
